import React from 'react';
import {
  Box,
  Paper,
  Divider,
  DialogContent,
  Stepper,
  Step,
  StepLabel,
  Stack,
  Typography,
} from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';

import TechApproveContainer from '../../../containers/techmng/approval/TechApproveContainer';
import TechFirstStepContainer from '../../../containers/techmng/support/TechFirstStepContainer';
import TechSecondStepContainer from '../../../containers/techmng/support/TechSecondStepContainer';
import TechThirdStepContainer from '../../../containers/techmng/support/TechThirdStepContainer';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-tech-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}



const steps = [
  { id: 1, value: '1', label: '지원요청', color: 'default' },
  { id: 2, value: '2', label: '지원확인', color: 'info' },
  { id: 3, value: '3', label: '작업계획', color: 'warning' },
  { id: 4, value: '4', label: '완료보고', color: 'error' },
  { id: 5, value: '5', label: '결재중', color: 'secondary' },
  { id: 6, value: '6', label: '결재완료', color: 'success' },
]

const TechEditStepperModal = ({
  open,
  project,
  activeStep,
  activeTab,
  tech,
  techPlan,
  techMids,
  techMidInfo,
  techRslt,
  user,
  handleClose,
  reloadTech,
  handleTabChange
}) => {


  if (!tech) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-tech-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-tech-dialog" onClose={handleClose}>
        <Stack direction="row" divider={<Divider orientation="vertical" flexItem />}
          spacing={2}>
          <Box>기술 요청 번호 : [{tech?.reqNo}]</Box>
          <Box>고객명 : {project?.partnerInc}</Box>
          <Box>사업명 : {project?.cstNm}</Box>
        </Stack>
        {tech?.rsltUuid !== null && (tech.reqGrade === "4" || tech.reqGrade === '5') && (
          <TechApproveContainer
            tech={tech}
            docuCd={tech?.rsltUuid}
            user={user}
            type="tech"
          />
        )}
      </BootstrapDialogTitle>
      <DialogContent
        dividers
        sx={{
          height: 700,
          overflowY: 'auto',
        }}
      >
        <Stepper
          sx={{
            pt: 2,
            pb: 1,
            backgroundColor: '#eee',
          }}
          activeStep={activeStep}
          alternativeLabel
        >
          {steps.map((step) => {
            const stepProps = {};
            const labelProps = {};

            if (activeStep >= step.id - 1) {
              let dateTime = "";
              if (step.id === 1) {
                dateTime = tech?.crtDt;
              } else if (step.id === 2) {
                dateTime = tech?.cngDt;
              } else if (step.id === 3) {
                dateTime = techPlan?.crtDt;
              } else if (step.id === 4) {
                dateTime = techRslt?.crtDt;
              } else {
                dateTime = techRslt?.cngDt;
              }
              labelProps.optional = (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography variant="caption" display="block">
                    {dateTime}
                  </Typography>
                </Box>
              );
            }


            if (activeStep === steps.length - 1) {
              stepProps.completed = true;
            }
            return (
              <Step key={step.label} {...stepProps}>
                <StepLabel
                  {...labelProps}
                >{step.label}</StepLabel>
              </Step>
            )
          })}
        </Stepper>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
          }}
        >
          {activeStep === 0 && (
            <TechFirstStepContainer
              project={project}
              tech={tech}
              user={user}
              activeTap={activeTab}
              handleTabChange={handleTabChange}
            />
          )}
          {activeStep === 1 && (
            <TechSecondStepContainer
              project={project}
              tech={tech}
              techPlan={techPlan}
              user={user}
              activeTap={activeTab}
              handleTabChange={handleTabChange}
              reloadTech={reloadTech}
            />

          )}

          {activeStep >= 2 && (
            <TechThirdStepContainer
              project={project}
              tech={tech}
              techPlan={techPlan}
              techMids={techMids}
              techMidInfo={techMidInfo}
              techRslt={techRslt}
              user={user}
              activeTap={activeTab}
              handleTabChange={handleTabChange}
              reloadTech={reloadTech}
            />
          )}
        </Box>


      </DialogContent>
    </BootstrapDialog>

  )
}
export default TechEditStepperModal